import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../../shared/services/authentication/authentication.service';
import { ResetPasswordConfirmDTO } from '../../../shared/dto/resetPasswordConfirmDTO';
import { take } from 'rxjs/operators';

// Page opened from the link emailed on account creation or password reset
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  resetPasswordForm: FormGroup;
  uid: string;
  token: string;
  // null while the link is being checked
  linkValid: boolean | null;
  errors: any;
  loading: boolean;
  genericError = "Une erreur est survenue lors de l'enregistrement du mot de passe";
  success: boolean;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
  ) {
    this.errors = {};
    this.linkValid = null;
    this.success = false;
    this.loading = false;
  }

  ngOnInit(): void {
    this.uid = this.route.snapshot.paramMap.get('uid');
    this.token = this.route.snapshot.paramMap.get('token');

    this.resetPasswordForm = this.formBuilder.group({
      new_password1: ['', Validators.required],
      new_password2: ['', Validators.required],
    });

    this.authenticationService.checkResetPasswordLink(this.uid, this.token).pipe(take(1)).subscribe(
      () => { this.linkValid = true; },
      () => { this.linkValid = false; });
  }

  // convenience getter for easy access to form fields
  get f() { return this.resetPasswordForm.controls; }

  onSubmit() {
    this.errors = {};

    if (this.resetPasswordForm.invalid) {
      this.errors['default'] = "Erreur: vérifiez les informations avant de les soumettre à nouveau"
      return;
    }

    this.loading = true;

    let resetPasswordConfirmDTO = new ResetPasswordConfirmDTO({
      uid: this.uid,
      token: this.token,
      new_password1: this.f.new_password1.value,
      new_password2: this.f.new_password2.value,
    });

    this.authenticationService.confirmResetPassword(resetPasswordConfirmDTO).pipe(take(1)).subscribe(
      () => {
        this.success = true;
        this.loading = false;
      },
      (err: any) => {
        this.loading = false;

        // The link expired or was used meanwhile
        if (err.error && err.error['token']) {
          this.linkValid = false;
          return;
        }

        if (err.error && (err.error['new_password1'] || err.error['new_password2'])) {
          for (let type in err.error) {
            this.errors[type] = err.error[type].join(' ');
          }
        } else {
          this.errors['default'] = this.genericError;
        }
      });
  }
}
